/* global globalThis */
import { SystemUsersEnum } from "../constants/SystemUsers";

const REPORT_ACCESS_ROLES = new Set([
  SystemUsersEnum.SUPERADMIN,
  SystemUsersEnum.ADMIN,
]);
const ENTERPRISE_ROLE = SystemUsersEnum.ENTERPRISE;
const SUPER_ADMIN_ROLE = SystemUsersEnum.SUPERADMIN;

const getNormalizedRoleId = (roleId) => {
  if (roleId !== undefined && roleId !== null && roleId !== "") {
    return Number(roleId);
  }

  if (globalThis.window === undefined) {
    return Number.NaN;
  }

  return Number(globalThis.window.localStorage.getItem("selectedRole"));
};

/**
 * Returns true when the role is allowed to access admin/super-admin report features.
 */
export const isSuperAdminOrAdminRole = (roleId) => {
  const normalizedRoleId = getNormalizedRoleId(roleId);
  return REPORT_ACCESS_ROLES.has(normalizedRoleId);
};

/**
 * Returns true when the role belongs to an Enterprise user.
 */
export const isEnterpriseUserRole = (roleId) =>
  getNormalizedRoleId(roleId) === ENTERPRISE_ROLE;

/**
 * Returns true when the role is strictly Super Admin.
 */
export const isOnlySuperAdminRole = (roleId) =>
  getNormalizedRoleId(roleId) === SUPER_ADMIN_ROLE;
